export default {"src":"/login-app/[GIT_HASH]/_next/static/media/abc.4a95ea77.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};